export default {"src":"/_next/static/media/gradient.7cee8aef.svg","height":4,"width":883,"blurWidth":0,"blurHeight":0};